import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Standalone dev entry only. In production the host shell mounts ./App via
// Module Federation and supplies these props itself (see GenericMFELoader).
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App basePath="/immo" apiBaseUrl="https://immo-api.main.awd.relaref.com" />
  </React.StrictMode>,
)
